<template>
  <div class="container">
    <div class="row nav">
      <div class="tab select four columns">ご利用明細</div>
      <div class="tab four columns">各種登録・変更</div>
    </div>

    <form @submit.prevent="showData">
      <select v-model="selectMonth">
        <option v-for="month in month" :value="month.value" :key="month.index">
          {{ month.text }}
        </option>
      </select>
      <button>表示する</button>
    </form>

    <div class="row">カード番号{{ username }}</div>
    <div class="row goukei">
      合計金額 <span class="total">{{ total | addComma }} 円</span>
    </div>

    <div class="row">
      <table class="u-full-width">
        <tr>
          <th>ご利用日</th>
          <th>ご利用先</th>
          <th>ご利用金額</th>
        </tr>
        <tbody v-for="cardData in cardData" :key="cardData.index">
          <tr>
            <td>{{ cardData.updated_at }}</td>
            <td>{{ cardData.contentName }}</td>
            <td class="right_text">{{ cardData.price | addComma }}円</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  data() {
    return {
      username: "",
      selectMonth: "",
      month: [
        { text: "1月", value: "1" },
        { text: "2月", value: "2" },
        { text: "3月", value: "3" },
        { text: "4月", value: "4" },
        { text: "5月", value: "5" },
        { text: "6月", value: "6" },
        { text: "7月", value: "7" },
        { text: "8月", value: "8" },
        { text: "9月", value: "9" },
        { text: "10月", value: "10" },
        { text: "11月", value: "11" },
        { text: "12月", value: "12" },
      ],
      cardData: {},
      total: 0,
    };
  },
  created: function () {
    this.selectMonth = new Date().getMonth() + 1;
    this.username = this.$store.state.userName;
    this.showData();
  },
  methods: {
    showData: function () {
      var m;
      this.total = 0;
      if (this.selectMonth < 10) {
        m = new Date().getFullYear() + "-0" + this.selectMonth;
      } else {
        m = new Date().getFullYear() + "-" + this.selectMonth;
      }
      var param =
        "?filter=cardNum,eq," +
        this.username.replace(/\s+/g, "") +
        "&filter=updated_at,cs," +
        m;
      this.$axios
        .get(this.$store.state.APIbase + "/records/cards" + param)
        .then((res) => {
          this.cardData = res.data.records;
          this.cardData.forEach((element) => {
            this.total = this.total + element.price;
          });
        });
    },
  },
};
</script>

<style scoped>
.nav {
  margin-top: 2rem;
  border-bottom: solid 3px #bae8e8;
}
.tab {
  background: #e3f6f5;
  border-radius: 10px 10px 0 0;
  padding: 5px;
  margin-left: 2px;
  text-align: center;
}
.select {
  background: #bae8e8;
  box-shadow: 1px -1px 1px rgba(0, 0, 0, 0.3);
}
.right_text {
  text-align: right;
}
.goukei {
  font-size: 2rem;
}
.total {
  font-size: 3rem;
  font-weight: bold;
}
@media (max-width: 699px) {
  .nav {
    border-bottom: none;
  }
  .tab {
    border-radius: 10px;
    margin: 5px;
  }
}

form {
  margin-top: 2rem;
}
</style>
